import { render, staticRenderFns } from "./GoodsReceive.vue?vue&type=template&id=5bc477b8&scoped=true"
import script from "./GoodsReceive.vue?vue&type=script&lang=js"
export * from "./GoodsReceive.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceive.vue?vue&type=style&index=0&id=5bc477b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc477b8",
  null
  
)

export default component.exports